import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { MonthlyExternalExpense, MonthlySalesTarget } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2430. Node管理外費用一覧
 * [GET] /workspaces/:identifier/monthly_external_expenses
 */
type Props = {
  identifier: string;
};

type MonthlyExternalExpensesResponse = {
  previous_external_expenses: MonthlyExternalExpense[];
  current_external_expenses: MonthlyExternalExpense[];
  next_external_expenses: MonthlyExternalExpense[];
};

const monthlyExternalExpenses = (props: Props): Promise<MonthlyExternalExpensesResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/monthly_external_expenses`, {
    params: props,
  });
};

export const useMonthlyExternalExpenses = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => monthlyExternalExpenses(props),
  });
};

export const useInvalidateMonthlyExternalExpenses = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'monthly_external_expenses'];
};
